export const allowedAtlassianFields: {
  Query: string[];
  Mutation: string[];
  Subscription: string[];
  directives: string[];
  enums: string[];
} = {
  Query: ['echo'],
  Mutation: [],
  Subscription: [],
  directives: [],
  enums: [],
};
